
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"55","viewBox":"0 0 540 620","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#e2001a"}},[_c('path',{attrs:{"d":"M4.5 4.5h531V350a265.5 265.5 0 01-531 0z","stroke":"#000","stroke-width":"9"}}),_c('g',{attrs:{"stroke":"#000","stroke-width":"4"}},[_c('path',{attrs:{"d":"M7 7h526v293H7z","fill":"#fff"}}),_c('path',{attrs:{"d":"M118 298v-9a13 13 0 0113-13h278a13 13 0 0113 13v9M150 274v-8a13 13 0 0113-13h214a13 13 0 0113 13v8"}}),_c('g',{attrs:{"id":"a","stroke-width":"8"}},[_c('circle',{attrs:{"cx":"384","cy":"193","r":"20"}}),_c('circle',{attrs:{"cx":"392","cy":"121","r":"20"}}),_c('circle',{attrs:{"cx":"353","cy":"58","r":"20"}}),_c('circle',{attrs:{"cx":"285","cy":"33","r":"20"}}),_c('circle',{attrs:{"cx":"217","cy":"49","r":"20"}}),_c('circle',{attrs:{"cx":"179","cy":"104","r":"20"}}),_c('circle',{attrs:{"cx":"201","cy":"169","r":"20"}})]),_c('path',{attrs:{"d":"M195 253c0-22 32-45 61-58 28-12 51-28 51-61a40 40 0 00-40-40 35 31 0 00-35 31 9 17 0 009 18 4 4 0 003-1 4 4 0 01-3 1 4 11 0 01-4-11 23 18 0 0123-18 24 24 0 0124 24 42 36 0 01-42 36 56 59 0 01-56-59 92 72 0 0192-72 105 98 0 01105 98c0 54-40 87-40 112z","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M241 143a25 28 0 01-25-28 54 46 0 0154-46 71 71 0 0171 71c0 52-70 81-70 112","fill":"none"}})]),_c('use',{attrs:{"xlink:href":"#a"}})])])
          )
        }
      }
    